export const existingProducts = [
  "Estación Portátil",
  "Estación Portátil Plus",
  "Estación Tipo Wallbox",
  "Estación Tipo Wallbox Plus",
  "Estación Tipo Wallbox con pedestal",
  "Estación Tipo Wallbox con método de pago",
  "Estación Tipo Wallbox doble",
  "Estación Pública",
  "Cargador Portátil Dual (Genérico)",
  "Probador de Estaciones",
  "Simulador de Estación",
  "Extensión VTOL",
  "Adaptador Tipo 1 a Tipo 2",
  "Adaptador Tipo 2 a Tipo 1",
  "Adaptador Tipo 1 a GB/T",
  "Adaptador CCS1 a CCS2",
  "Adaptador ChaDeMO a GB/T",
  "Convertidor VTOL",
  "Kit de pared",
];

export const stations = [
  {
    id: "EV1",
    productName: "Estación Portátil",
    description:
      "Estación de carga portátil (L2 o Dual) para vehículos eléctricos",
  },
  {
    id: "EV2",
    productName: "Estación Portátil Plus",
    description:
      "Estación de carga portátil (L2 o Dual) para vehículos eléctricos",
  },
  {
    id: "EV3",
    productName: "Estación Tipo Wallbox",
    description:
      "Estación de carga inteligente (conexión a WiFi y acceso a la aplicación ATILA) para vehículos eléctricos",
  },
  {
    id: "EV4",
    productName: "Estación Pública",
    description:
      "Estación de carga inteligente (conexión a WiFi y acceso a la aplicación ATILA) y resistente (acero inoxidable de grado marino) para vehículos eléctricos",
  },
  {
    id: "EV5",
    productName: "Estación Tipo Wallbox con pedestal",
    description:
      "Estación de carga inteligente (conexión a WiFi y acceso a la aplicación ATILA) y resistente (acero inoxidable de grado marino) para vehículos eléctricos",
  },
  {
    id: "EV6",
    productName: "Estación Tipo Wallbox con método de pago",
    description:
      "Estación de carga inteligente (conexión a WiFi y acceso a la aplicación ATILA) y resistente (acero inoxidable de grado marino) para vehículos eléctricos",
  },
  {
    id: "EV7",
    productName: "Estación Tipo Wallbox doble",
    description:
      "Estación de carga inteligente (conexión a WiFi y acceso a la aplicación ATILA) y resistente (acero inoxidable de grado marino) para vehículos eléctricos",
  },
  {
    id: "EV8",
    productName: "Estación Tipo Wallbox Plus",
    description:
      "Estación de carga inteligente (conexión a WiFi, acceso a la aplicación ATILA y pantalla táctil) para vehículos eléctricos",
  },
  {
    id: "EV9",
    productName: "Cargador Portátil Dual (Genérico)",
    description:
      "Cargador portátil (L2 o Dual) para vehículos eléctricos.",
  },
];

export const accesories = [
  {
    id: "A1",
    productName: "Probador de Estaciones",
    description: "Probador de estaciones de carga semi-rápidas (L2)",
  },
  {
    id: "A2",
    productName: "Simulador de Estación",
    description: "Simulador de estación de carga ELCO inteligente",
  },
  {
    id: "A3",
    productName: "Extensión VTOL",
    description: "Regleta VTOL (Vehicle to load) para vehículos eléctricos ",
  },
  {
    id: "A4",
    productName: "Adaptador Tipo 1 a Tipo 2",
    description:
      "Adaptador Tipo 1 a Tipo 2 para vehículos eléctricos en cargadores semi-rápidos (L2)",
  },
  {
    id: "A5",
    productName: "Adaptador Tipo 2 a Tipo 1",
    description:
      "Adaptador Tipo 2 a Tipo 1 para vehículos eléctricos en cargadores semi-rápidos (L2)",
  },
  {
    id: "A6",
    productName: "Adaptador Tipo 1 a GB/T",
    description:
      "Adaptador Tipo 1 a GB/T para vehículos eléctricos en cargadores semi-rápidos (L2)",
  },
  {
    id: "A7",
    productName: "Adaptador CCS1 a CCS2",
    description:
      "Adaptador CCS1 a CCS2 para vehículos eléctricos en cargadores rápidos (L3)",
  },
  {
    id: "A8",
    productName: "Adaptador ChaDeMO a GB/T",
    description:
      "Adaptador CHAdeMO a GB/T para vehículos eléctricos en cargadores rápidos (L3)",
  },
  {
    id: "A9",
    productName: "Convertidor VTOL",
    description:
      "Convertidor VTOL (Vehicle to load) para vehículos eléctricos ",
  },
  {
    id: "A10",
    productName: "Kit de pared",
    description: "Kit de pared para estaciones de carga portátiles",
  },
];

export const others = [
  {
    id: "O1",
    productName: "Otro producto",
    description: "Cualquier producto",
  },
];
